import { ThemeProvider, theme } from '@everlywell/ui-kit';
import React, { ReactNode } from 'react';

import Header from '../components/Header';
import GlobalStyle from '../styles/global';
import config from '../utils/siteConfig';
import FooterV2 from './FooterV2/FooterV2';

interface TemplateProps {
  children: ReactNode;
}

export const Head: React.FC = () => (
  <>
    <title>{config.siteTitle}</title>
    <meta charSet="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
  </>
);

const Template: React.FC<TemplateProps> = ({ children }) => (
  <div className="siteRoot">
    <ThemeProvider theme={theme}>
      <Header />
      <div className="siteContent">{children}</div>
      <FooterV2 />
    </ThemeProvider>

    <GlobalStyle />
  </div>
);

export default Template;
